import Type from "@/model/types/Type";
import VarType from "@/model/types/resource/VarType"
import InputType from "@/model/types/resource/InputType"
import ui from "@/assets/scripts/ui"


const type = {
    NOT_USE: 99,
    BIGGER: 1,
    BIGGER_OR_EQUAL: 2,
    LESS: 3,
    LESS_OR_EQUAL: 4,
    EQUAL: 5,
    NOT_EQUAL: 6,
    IN: 7,
    NOT_IN: 8,
}

const list = [
    {
        value: type.NOT_USE,
        text: "Não utilizar",
        typeBoolean: true,
        typeString: true,
        typeList: true,
        enableFinalValue: false
    },
    {
        value: type.BIGGER,
        text: "é maior que",
        typeBoolean: false,
        typeString: false,
        typeList: false,
        enableFinalValue: false
    },
    {
        value: type.BIGGER_OR_EQUAL,
        text: "é maior ou igual que",
        typeBoolean: false,
        typeString: false,
        typeList: false,
        enableFinalValue: false
    },
    {
        value: type.LESS,
        text: "é menor que",
        typeBoolean: false,
        typeString: false,
        typeList: false,
        enableFinalValue: false
    },
    {
        value: type.LESS_OR_EQUAL,
        text: "é menor ou igual que",
        typeBoolean: false,
        typeString: false,
        typeList: false,
        enableFinalValue: false
    },
    {
        value: type.EQUAL,
        text: "é igual a",
        typeBoolean: true,
        typeString: true,
        typeList: true,
        enableFinalValue: false
    },
    {
        value: type.NOT_EQUAL,
        text: "é diferente de",
        typeBoolean: false,
        typeString: true,
        typeList: true,
        enableFinalValue: false
    },
    {
        value: type.IN,
        text: "está entre",
        typeBoolean: false,
        typeString: false,
        typeList: false,
        enableFinalValue: true
    },
    {
        value: type.NOT_IN,
        text: "não está entre",
        typeBoolean: false,
        typeString: false,
        typeList: false,
        enableFinalValue: true
    }
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

const getConditionRuleName = function (condition) {


    const typeCondition = list.find(a => a.value === condition.typeCondition)


    let text = "'" + condition.name + "'" + ' ' + typeCondition.text

    if (condition.var === VarType.type.INTEGER) {


        if (InputType.isList(condition.type)) {

            const item = condition.options.find(a => a.value === condition.referenceValueIntegerInitial)

            if(item !== undefined){
                text += ' \'' +item.text + '\''
            }

        } else {


            text += ' ' + condition.referenceValueIntegerInitial

            if (typeCondition.enableFinalValue) {
                text += ' a ' + condition.referenceValueIntegerFinal
            }

        }

    } else if (condition.var === VarType.type.DOUBLE) {

        text += ' ' + ui.convertNumber(condition.referenceValueDoubleInitial, condition.decimalPrecision, "pt-br")

        if (typeCondition.enableFinalValue) {
            text += ' a ' + ui.convertNumber(condition.referenceValueDoubleFinal, condition.decimalPrecision, "pt-br")
        }

    } else if (condition.var === VarType.type.BOOLEAN) {

        if (condition.referenceValueBoolean) {
            text += ' selecionado'
        } else {
            text += ' não selecionado'
        }
    } else if (condition.var === VarType.type.STRING) {

        text += ' ' + condition.referenceValueString

    } else if (condition.var === VarType.type.DATE) {

        text += ' ' + ui.convertDateBR(condition.referenceValueDateInitial)

        if (typeCondition.enableFinalValue) {
            text += ' a ' + ui.convertDateBR(condition.referenceValueDateFinal)
        }

    }

    return text

}

export default {
    type,
    list,
    contains,
    getConditionRuleName
}